import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { Reveal } from "@/components/Reveal";
import { LieuBooking } from "@/components/LieuBooking";
import { useNoIndex } from "@/lib/seo";
import { useSeo } from "@/lib/seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Suivi = () => {
  useSeo({ title: "Suivi de réservation · Entre Les Mondes", description: "", noindex: true });
  useNoIndex();
  const { id } = useParams();
  const [prefill, setPrefill] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    document.title = "Réserver un suivi de lieu — Entre les Mondes";
    axios.get(`${API}/bookings/${id}/suivi`).then((r) => { setPrefill({ ...r.data, id }); setState("ok"); }).catch(() => setState("error"));
  }, [id]);

  if (state === "loading") return <div className="pt-44 pb-32 text-center"><Loader2 className="w-8 h-8 text-terra mx-auto animate-spin" /></div>;
  if (state === "error") {
    return (
      <div className="pt-44 pb-32 text-center" data-testid="suivi-notfound">
        <p className="font-serif text-3xl text-bark mb-6">Cette visite est introuvable.</p>
        <Link to="/offres/lieux-habitats" className="link-line text-terra">Réserver une visite de lieu</Link>
      </div>
    );
  }
  return (
    <div className="pt-36 pb-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="mb-10">
          <p className="eyebrow mb-6">Suivi de lieu — CHF 120.– ponctuel · CHF 290.– annuel</p>
          <h1 className="font-serif text-4xl lg:text-5xl text-bark leading-tight" data-testid="suivi-title">Bonjour {prefill.nom.split(" ")[0]}, vérifions comment respire votre lieu.</h1>
          <p className="text-fumee mt-5 max-w-xl leading-relaxed">
            Suite à votre visite du {new Date(prefill.event_date).toLocaleDateString("fr-CH", { day: "numeric", month: "long", year: "numeric" })} ({prefill.adresse_lieu}), vos coordonnées sont déjà remplies : il ne reste qu'à choisir le type de suivi, le jour et l'heure.
          </p>
        </Reveal>
        <LieuBooking prefill={prefill} suivi />
      </div>
    </div>
  );
};

export default Suivi;
